// Masks for CNPJ, Phone, UF

function maskCNPJ(value) {
    value = value.replace(/\D/g, '');
    if (value.length > 14) value = value.substring(0, 14);
    if (value.length <= 2) return value;
    if (value.length <= 5) return value.replace(/(\d{2})(\d{1,3})/, '$1.$2');
    if (value.length <= 8) return value.replace(/(\d{2})(\d{3})(\d{1,3})/, '$1.$2.$3');
    if (value.length <= 12) return value.replace(/(\d{2})(\d{3})(\d{3})(\d{1,4})/, '$1.$2.$3/$4');
    return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{1,2})/, '$1.$2.$3/$4-$5');
}



function maskPhone(value) {
    // Remove all non-digit characters
    value = value.replace(/\D/g, '');

    // Limit to max 11 digits (2 for area code + 9 for number)
    if (value.length > 11) {
        value = value.substring(0, 11);
    }

    if (value.length <= 10) {
        return value.replace(/(\d{2})(\d{4})(\d{0,4})/, function(match, p1, p2, p3) {
            return '(' + p1 + ') ' + p2 + (p3 ? '-' + p3 : '');
        });
    } else {
        return value.replace(/(\d{2})(\d{5})(\d{0,4})/, function(match, p1, p2, p3) {
            return '(' + p1 + ') ' + p2 + (p3 ? '-' + p3 : '');
        });
    }
}

function maskUF(value) {
    return value.toUpperCase();
}

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.cnpj').forEach(function(el) {
        el.addEventListener('input', function(e) {
            e.target.value = maskCNPJ(e.target.value);
            e.target.setSelectionRange(e.target.value.length, e.target.value.length);
        });
    });

    document.querySelectorAll('.telefone').forEach(function(el) {
        el.addEventListener('input', function(e) {
            if (e.target.dataset.masking) return;
            e.target.dataset.masking = 'true';
            e.target.value = maskPhone(e.target.value);
            // Set cursor at the end after masking to avoid cursor jump issues
            const length = e.target.value.length;
            e.target.setSelectionRange(length, length);
            delete e.target.dataset.masking;
        });
    });

    document.querySelectorAll('.UF').forEach(function(el) {
        el.addEventListener('input', function(e) {
            e.target.value = maskUF(e.target.value);
        });
    });
});
